import React from 'react';
import SettlementIntelligenceDashboard from '../components/analytics/SettlementIntelligenceDashboard';

export default function SettlementIntelligencePage() {
  return <SettlementIntelligenceDashboard />;
}
